@if (platformBrowser) {
  <router-outlet></router-outlet>
  <div
    class="view-gallery-page"
    [style.--gallery-background-color]="gallery.layout_background_color || 'white'"
    [class.dark]="gallery.layout_background_color | isDarkColor"
  >
    @if (!oldEmbedMode) {
      <div class="header-container">
        @if (previewMode()) {
          <div class="preview-banner">
            <app-svg src="/assets/icons/globe-eye.svg" color="primary"></app-svg>
            <div>
              <b>Gallery Preview</b>
              <span>This is what people with the link will see.</span>
            </div>

            <a
              [href]="correctPicflowUrl + '/a/gallery/' + gallery.id"
              appButton
              name="edit"
              location="view-gallery-page"
              color="primary"
              shape="round"
              height="0"
              spacing="4"
              size="0-5"
            >
              Edit
            </a>

            <button
              appButton
              class="close-preview-button"
              name="close-preview"
              location="view-gallery-page"
              color="simple-gray"
              height="0"
              [iconButton]="true"
              shape="round"
              (click)="previewMode.set(false)"
            >
              <app-svg src="/assets/icons/cross.svg"> </app-svg>
            </button>
          </div>
        }
        <app-view-gallery-header
          [gallery]="gallery"
          [accessLevel]="accessLevel"
          [mode]="'layout'"
          (onFilterChange)="onFilter($event)"
          #header
        ></app-view-gallery-header>
      </div>
    }
    @if (gallery.cover.uuid && accessLevel !== 'view_only') {
      <div class="header-gradient"></div>
    }
    @if ((gallery.cover.uuid || gallery.title || gallery.description) && !embedSettings.hideCover) {
      <app-gallery-cover
        [gallery]="gallery"
        [tenant]="tenant"
        [darkGalleryBackground]="gallery.layout_background_color | isDarkColor"
      ></app-gallery-cover>
    }
    @if (!gallery.cover.uuid && !gallery.title && !gallery.description) {
      <div class="no-cover-spacer"></div>
    }
    <div #galleryBody class="content-container">
      <div>
        @if (noAssetsResult) {
          <div class="no-results" [class.dark]="gallery.layout_background_color | isDarkColor">
            <h3>No assets found</h3>
            <button
              (click)="resetFilter()"
              appButton
              color="default-opacity"
              name="reset-view-search-filter"
              location="view-gallery-page"
              shape="round"
              [center]="true"
            >
              Reset Filter
            </button>
          </div>
        }
        @if (sections$ | async; as sections) {
          @for (section of sections | sortBy: 'position'; track section.id; let i = $index) {
            @if (section.object === 'asset' || !filters.length) {
              <div
                class="section-container v-padding-{{ section.vertical_padding }}"
                [style.background-color]="section.layout_background_color"
              >
                <div
                  class="section-content"
                  [style.max-width]="section.object === 'asset' ? undefined : section.width + 'px'"
                  [class.no-padding]="section.object === 'asset'"
                >
                  @if (section.object !== 'text' && section.text_title) {
                    <app-text-section
                      class="section-title"
                      [section]="section"
                      [gallery]="gallery"
                      [darkBackground]="
                        section.layout_background_color || gallery.layout_background_color | isDarkColor
                      "
                      [class.with-padding]="section.object === 'asset'"
                    ></app-text-section>
                  }

                  @if (section.object === 'gallery') {
                    <app-album-section
                      [section]="section"
                      [parentGallery]="gallery"
                      [embedMode]="oldEmbedMode"
                    ></app-album-section>
                  }
                  @if (section.object === 'text') {
                    <app-text-section
                      [section]="section"
                      [gallery]="gallery"
                      [darkBackground]="
                        section.layout_background_color || gallery.layout_background_color | isDarkColor
                      "
                    ></app-text-section>
                  }
                  @if (section.object === 'asset' && section.position !== 612512) {
                    <app-assets-section
                      [section]="section"
                      [gallery]="gallery"
                      [accessLevel]="accessLevel"
                      [filters]="filters"
                      [embedMode]="oldEmbedMode"
                      [blockEmbedAssetView]="embedSettings.blockAssetView"
                      [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions"
                      [darkBackground]="
                        section.layout_background_color || gallery.layout_background_color | isDarkColor
                      "
                      [approvedAssetCount]="approvedAssetCount$ | async"
                    >
                    </app-assets-section>
                  }
                  @if (section.object === 'embed') {
                    <app-embed-section [section]="section" [gallery]="gallery"> </app-embed-section>
                  }
                </div>
              </div>
            }
          }
        }
      </div>
    </div>
    @if (!oldEmbedMode) {
      <div class="gallery-footer brand">
        <app-tenant-logo-and-contacts
          [tenant]="tenant"
          [link]="['/']"
          [small]="true"
          [darkBg]="gallery.layout_background_color | isDarkColor"
        ></app-tenant-logo-and-contacts>
        @if (
          (!gallery || gallery.tenant?.['picflow_branding_enabled']) &&
          gallery['tenant_product_name'] !== 'Picflow Free'
        ) {
          <app-made-with-picflow-button
            [tenantId]="tenant.id"
            [darkBackground]="gallery.layout_background_color | isDarkColor"
          >
          </app-made-with-picflow-button>
        }
      </div>
    }
  </div>
  @if (gallery?.approval_limits) {
    <app-approval-limit-info [gallery]="gallery"></app-approval-limit-info>
  }
}
